import React from "react";
import IconTime from "../../assets/svg/IconTime";
import IconWithLabel from "./IconWithLabel";

const DurationIcon = (props) => {
	return <IconWithLabel Icon={IconTime} {...props} iconColor={props.color} />;
};

export default DurationIcon;
